import * as React from 'react';
const useEnhancedEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
export default useEnhancedEffect;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/utils/esm/useEnhancedEffect.js
// module id = 476
// module chunks = 1